import { CommentTemplateState } from './comment-template-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  updateResourceByParam,
  deleteResourceByParam,
} from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: CommentTemplateState = {
  commentTemplatesById: {},
  commentTemplatesStateByJobId: {},
  commentTemplatesStateByOrgId: {},
};

export const commentTemplateReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_COMMENT_TEMPLATES'): {
      const { jobId, orgId } = action.payload.args;
      return jobId
        ? updateResourceByParam(state, 'commentTemplates', 'jobId', jobId, true)
        : updateResourceByParam(state, 'commentTemplates', 'orgId', orgId, true);
    }
    case SUCCESS('LOAD_COMMENT_TEMPLATES'): {
      const {
        args: { jobId, orgId },
        data,
      } = action.payload;
      return jobId
        ? updateResourceByParam(
            state,
            'commentTemplates',
            'jobId',
            jobId,
            false,
            convertArrayToMap(data, (d: CommentTemplate) => String(d.commentTemplateId)),
          )
        : updateResourceByParam(
            state,
            'commentTemplates',
            'orgId',
            orgId,
            false,
            convertArrayToMap(data, (d: CommentTemplate) => String(d.commentTemplateId)),
          );
    }
    case FAILURE('LOAD_COMMENT_TEMPLATES'): {
      const { jobId, orgId } = action.payload.args;
      return jobId
        ? updateResourceByParam(state, 'commentTemplates', 'jobId', jobId, false)
        : updateResourceByParam(state, 'commentTemplates', 'orgId', orgId, false);
    }
    case SUCCESS('CREATE_COMMENT_TEMPLATE'):
    case SUCCESS('UPDATE_COMMENT_TEMPLATE'): {
      const {
        data,
        args: { jobId, orgId },
      } = action.payload;
      const { commentTemplateId } = data;

      if (data.isActive === false) {
        return jobId
          ? deleteResourceByParam(state, 'commentTemplates', 'jobId', jobId, data.commentTemplateId)
          : deleteResourceByParam(
              state,
              'commentTemplates',
              'orgId',
              orgId,
              data.commentTemplateId,
            );
      }
      return jobId
        ? updateResourceByParam(state, 'commentTemplates', 'jobId', jobId, false, {
            [commentTemplateId]: data,
          })
        : updateResourceByParam(state, 'commentTemplates', 'orgId', orgId, false, {
            [commentTemplateId]: data,
          });
    }
    default: {
      return state;
    }
  }
};
